import React from 'react';

import { NumberInput, NumberInputProps } from '@mantine/core';

type ITaxRatePercentageInputProps = Omit<NumberInputProps, 'formatter' | 'parser' | 'precision' | 'step'>;

const TaxRatePercentageInput = ({ ...numberInputProps }: ITaxRatePercentageInputProps): JSX.Element => {
  return (
    <NumberInput
      parser={value => value.replace(/\%\s?|(,*)/g, '')}
      formatter={value =>
        !Number.isNaN(parseFloat(value))
          ? `${value} %`.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
          : '0.000 %'
      }
      min={0}
      max={100}
      precision={3}
      step={1}
      {...numberInputProps}
    />
  );
};

export default TaxRatePercentageInput;
